export enum AzureOnboardingHelp {
  GettingManagementGroupId,
  GettingSubscriptionId,
  ManagementGroupPermissions,
  InputParameters,
  Remediation,
  None,
  Onboarding,
}
